import { render, staticRenderFns } from "./GridShared.vue?vue&type=template&id=6b2c5053&"
import script from "./GridShared.vue?vue&type=script&lang=js&"
export * from "./GridShared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports